module.exports = function ($container) {
	var MIN_QUERY_LENGTH = 2;
	var lastSearch;
	window.dropdownTypeAheadCache = {};
	var $searchInputs = $container.find('.search-bar__input');

	$.each($searchInputs, function (inputIndex, inputItem) {

		var $searchInput = $(inputItem);
		var inputContentVal = $searchInput.attr('id');

		var typeAheadDropdownContainer = $container.find('.search-bar__suggestions.type-ahead-dropdown');
		var popularSearchDropdownContainer = $container.find('.search-bar__suggestions:not(.type-ahead-dropdown)');
		var outerContainer = typeAheadDropdownContainer.parents('.search-bar__inner');
		var searchPageUrl = typeAheadDropdownContainer.data('url');

		var clearTypeAhead = function () {
			typeAheadDropdownContainer.html('');
			typeAheadDropdownContainer.removeClass('has-suggestions');
			outerContainer.removeClass('has-suggestions');
			outerContainer.removeClass('has-dropdown-suggestions');
			popularSearchDropdownContainer.show();
		};

		// when typing
		$searchInput.keyup(function (e) {
			var currentVal = $searchInput.val();

			if (currentVal.indexOf(' ') === -1 && currentVal.length >= MIN_QUERY_LENGTH) {
				var updateDropdownTypeAhead = function (words, val) {
					if ($searchInput.val() !== val) {
						return;
					}

					var previousSearchResults = lastSearch ? window.dropdownTypeAheadCache[lastSearch] : [];
					var shouldUpdate = false;

					if (previousSearchResults.length !== words.length ||
						!outerContainer.hasClass('has-dropdown-suggestions')) {
						shouldUpdate = true;
					}

					if (!shouldUpdate) {
						for (var i = 0; i < words.length; ++i) {
							if (words[i] !== previousSearchResults[i]) {
								shouldUpdate = true;
								break;
							}
						}
					}

					if (shouldUpdate) {
						clearTypeAhead();

						words.forEach(function (currentValue, index, arr) {

							var link = $('<a href="' + searchPageUrl + '?q=' +
								currentValue +
								'" class="search-bar__suggestion">' +
								currentValue +
								'</a>');
							typeAheadDropdownContainer.append(link);
						});
						typeAheadDropdownContainer.addClass('has-suggestions');
						outerContainer.addClass('has-suggestions');
						outerContainer.addClass('has-dropdown-suggestions');
						popularSearchDropdownContainer.hide();
					}

					lastSearch = currentVal;
				}

				if (currentVal in window.dropdownTypeAheadCache) {
					updateDropdownTypeAhead(window.dropdownTypeAheadCache[currentVal], currentVal);
					return;
				}

				Innophos.Modules.SiteSearchBar.TypeAheadSearch(currentVal, function (results) {
					if (results && results.results && results.results.length) {
						var matchedValues = results.results;

						window.dropdownTypeAheadCache[currentVal] = matchedValues;
						updateDropdownTypeAhead(matchedValues, currentVal);
					}
					else {
						lastSearch = '';
						clearTypeAhead();
					}
				});
			}
			else {
				clearTypeAhead();

				if (currentVal.length == 0) {
					outerContainer.addClass('has-suggestions');
				}
			}
		});
	});
};
